<div class="component-container">
  <div
    class="score-panel justify-center items-center flex flex-row flex-wrap gap-[2.4rem]">
    <div
      *ngIf="showDetailsForAdult || lastSession >=2"
      class="score-card flex flex-col
            justify-center items-center grow"
    >
      <div
        class="card-heading flex flex-row justify-center items-center">
        <app-icon
          class="red-light-icon"
          svgIcon="red-light"
        ></app-icon>
        <span class="title">
          Daily Red Light Foods
        </span>
        <app-icon
          [matTooltip]="'Type in your behavior tracker \n\n totals from your paper journal \n\n or use your e-journal.'"
          class="info-icon ml-[1rem]"
          matTooltipClass="custom-tooltip"
          matTooltipPosition="above"
          svgIcon="info"
        />
      </div>
      <app-number-input
        [parentFormGroup]="form"
        class="red-light-input w-[13.8rem]"
        controlName="redLight"
        label="Red Light Foods"
        type="small"
      />
      <div class="flex space-x-[1rem]">
        <span
          (click)="redirectToJournal()"
          class="clickable-text"
        >
        Food e-Journal
        </span>
        <app-icon *ngIf="data?.eJournalRLExists"
                  svgIcon="check-circle"></app-icon>
      </div>
    </div>
    <div
      *ngIf="showDetailsForAdult || lastSession >=8"
      class="score-card flex flex-col
            justify-center items-center grow"
    >
      <div class="card-heading flex flex-row justify-center items-center">
        <app-icon
          class="physical-activity-icon"
          svgIcon="physical-activity"
        ></app-icon>
        <span class="title">
        Daily Physical Activity
      </span>
        <app-icon
          [matTooltip]="'Type in your behavior tracker \n\n totals from your paper journal \n\n or use your e-journal.'"
          class="info-icon ml-[1rem]"
          matTooltipClass="custom-tooltip"
          matTooltipPosition="above"
          svgIcon="info"
        ></app-icon>
      </div>
      <span class="label">
        Physical Activity Points
      </span>
      <app-number-input
        [parentFormGroup]="form"
        class="physical-activity-input w-[13.8rem]"
        controlName="physicalActivity"
        type="small"
        [showNumberSeparator]="true"
      ></app-number-input>
      <div class="flex space-x-[1rem]">
        <span (click)="redirectToJournal()"
              class="clickable-text"
        >
        Activity e-Journal
        </span>
        <app-icon *ngIf="data?.eJournalPAExists"
                  svgIcon="check-circle"></app-icon>
      </div>
    </div>
    <div
      *ngIf="showDetailsForAdult || lastSession >=15"
      class="score-card flex flex-col
            justify-center items-center grow"
    >
      <div class="card-heading flex flex-row justify-center items-center">
        <app-icon
          class="screen-time-icon"
          svgIcon="screen-time"
        ></app-icon>
        <span class="title">
        Daily Screen Time
      </span>
        <app-icon
          [matTooltip]="'Type in your behavior tracker \n\n totals from your paper journal \n\n or use your e-journal.'"
          class="info-icon ml-[1rem]"
          matTooltipClass="custom-tooltip"
          matTooltipPosition="above"
          svgIcon="info"
        ></app-icon>
      </div>
      <div class="row w-[13.8rem] flex flex-row space-x-[0.8rem]">
        <app-number-input
          [parentFormGroup]="form"
          class="hours-input w-[6.4rem]"
          controlName="hours"
          label="Hours"
          type="small"
        ></app-number-input>
        <app-number-input
          [parentFormGroup]="form"
          class="minutes-input w-[6.4rem]"
          controlName="minutes"
          label="Minutes"
          type="small"
        ></app-number-input>
      </div>
      <div class="flex space-x-[1rem]">
        <span (click)="redirectToJournal()"
              class="clickable-text"
        >
        Screen Time e-Journal
        </span>
        <app-icon *ngIf="data?.eJournalSTExists"
                  svgIcon="check-circle"></app-icon>
      </div>
    </div>
  </div>
  <div class="action-section flex flex-col space-y-[2.4rem] w-full mb-[2.4rem]">
    <span class="flex flex-row justify-center w-full">
       <app-primary-button
         (handleClick)="save()"
         [isDisabled]="!form.dirty"
         [isLoading]="dailyScoreUpdateLoader"
         class="save w-[14.6rem]"
         type="small"
       >
     Save
    </app-primary-button>
    </span>
    <hr
      class="line-break w-full
             border-t-[#C2C1D5]
             border-t-[0.1rem]"
    >
  </div>
</div>
